/* eslint-disable */
/* eslint-disable no-tabs */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import { Button, Tooltip } from '@mui/material';
import { connect, useDispatch } from 'react-redux';
import { useEffect, useMemo, useRef, useState } from 'react';
import moment from 'moment';
import { useHistory } from 'react-router';
import { Filter, RefreshCcw } from 'lucide-react';
import { analyticsAction, formActions, modalActions } from '../../../Actions';
import { ListTable } from '../../../Components/ListTable';
import styles from './VendorOrdersListPage.module.scss';
import { notificationServices } from '../../../Services';
import ImagesFinder from '../../../Components/ImagesFinder/ImagesFinder';
import {
	addCommas,
	classes, filtersInfoChip, handleOrderStatus, handleResponseStreamDownload
} from '../../../Helpers';
import { urls } from '../../../Constants';
import drawerActions from '@/Actions/drawer.actions';
import orderAnalyticsServices from '@/Services/Analytics Services/orderAnalytics.services';
import { useAuth } from '@/Components/Auth/Login/auth';
import authActions from '@/Actions/auth.actions';
import { BackdropLoader } from '@/Components/Loaders';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import GlobalSearch from '@/Components/globalSearch/search';
import { getStorageKey } from '../CreatePurchaseOrder/CreatePurchaseOrder.config';
import { loadState } from '@/Helpers/persistenceUtils';
import MultiPoModal from '@/Components/Modals/MultiPoModal/multiPoModal';

// Buyer-specific table columns
const BUYER_TABLE_COLUMNS = [
	{
		title: 'SO Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Client SO Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Ref No',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Dispatch By',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Buyer',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Deliver From',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'CREATED BY',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Last Action BY',
		config: {
			type: 'DATA',
		},
	},
];

const BUYER_SPECIAL_COLUMNS = [
	{
		title: 'Order Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Amount',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Status',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Repush',
		config: {
			type: 'DATA',
		},
	},
];

const BUYER_COLMAP = {
	'SO Id': 'id',
	'Client SO Id': 'clientPoId',
	'Order Ref No': 'externalOrderRef',
	'Order Date': 'createdAt',
	'Dispatch By': 'scheduledAt',
	'Deliver From': 'fromStoreName',
	'Order Status': 'id',
	Buyer: 'vendorName',
	'CREATED BY': 'initiatedByName',
	'Last Action BY': 'l1ActionByName',
	'Order Amount': 'id',
	'Repush': 'id',
};

const buyerOrderStatus = [
	'CANCELLED',
	'PENDING',
	'FULFILLED',
	'APPROVAL_PENDING',
	'APPROVAL_REJECTED',
	'ABANDONED',
	'DISPATCH',
	'TRANSIT',
	'UNLOADING',
	'VERIFICATION',
];

const buyerDateTypeArr = [
	{
		label: 'Order Date',
		value: 'ordered',
	},
	{
		label: 'Scheduled For',
		value: 'scheduled',
	},
	{
		label: 'Invoice Date',
		value: 'invoiced',
	}
];

const buyerOrdersExportTypes = [
	{
		label: 'Invoice-Wise Sales Register',
		value: 'invoiceWise',
	},
	{
		label: 'Item-Wise Sales Register',
		value: 'grnItemWise',
	},
	{
		label: 'Item-Wise SO Fulfillment',
		value: 'poItemWise',
	},
	{
		label: 'Shipment-Wise (POD)',
		value: 'shipmentWise',
	},
];

function BuyerOrderList(props) {
	const {
		data,
		toggleModal,
		toggleAlert,
		fetchOrdersList,
		navState,
		subCategoriesList,
		fetchSubCategories,
		resetInventoryAnalyticsState,
		toggleDebitCreditListDrawer,
		toggleOrderImagesModal,
		toggleExportFiltersDrawer,
		categoriesList,
		toggleFiltersDrawer,
		vendors,
		fetchVendors,
		userList,
		fetchUserList,
	} = props;

	const history = useHistory();
	const location = useLocation();
	const [loading, setLoading] = useState(false);
	const [update, setUpdate] = useState(-1);
	const exportFilters = useRef({});
	const [search, setSearch] = useState({});
	const [filterValue, setFilterValue] = useState({});
	const [isRefresh, setIsRefresh] = useState(false);
	const [datePickerModalState, setDatePickerModalState] = useState({
		show: false,
		heading: '',
		currentPo: null,
	});
	const [filters, setFilters] = useState({
		storeId: null,
		dateRange: {
			startDate: new Date(),
			endDate: new Date(),
		},
	});

	const { userConfig = {}, appConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};
	const dispatch = useDispatch();
	const navRequisites = navState?.[urls.PURCHASE_ORDERS]?.requisites ?? [];
	const navSelectedStore = navRequisites?.find((ele) => {
		return ele?.type === 'store';
	});

	// Status styling based on the colors you provided
	const getStatusStyle = (status) => {
		const statusStyles = {
			DISPATCH: { background: 'rgba(255, 217, 0, 0.5)', color: '#b38600' },
			TRANSIT: { background: 'rgba(0, 128, 128, 0.5)', color: '#004d4d' },
			UNLOADING: { background: 'rgba(255, 208, 0, 0.5)', color: '#b37700' },
			VERIFICATION: { background: 'rgba(30, 255, 0, 0.25)', color: '#1b7300' },
			FULFILLED: { background: 'rgba(0, 128, 0, 0.5)', color: '#006600' },
			CLOSED: { background: '#bbf7d0', color: '#166534' },
			CANCELLED: { background: '#fecaca', color: '#991b1b' },
			ABANDONED: { background: '#64748b', color: '#cbd5e1' },
			APPROVAL_PENDING: { background: 'rgba(255, 187, 0, 0.25)', color: '#b38600' },
			APPROVAL_REJECTED: { background: 'rgba(255, 0, 0, 0.25)', color: '#991b1b' },
		};

		return statusStyles[status];
	};

	useEffect(() => {
		exportFilters.current = {
			...exportFilters.current,
			storeId:
				navSelectedStore?.value?.id === -999
					? null
					: navSelectedStore?.value?.id,
		};
	}, [navSelectedStore?.value?.id]);

	// Discard a buyer-order draft older than 30 minutes on load, so a stale
	// draft never resurfaces in the "Draft Exists" prompt or the Edit Draft button.
	useEffect(() => {
		const DRAFT_TTL_MS = 30 * 60 * 1000;
		const key = getStorageKey(8); // Buyer type
		const draft = loadState(key);
		if (
			draft &&
			(!draft.draftSavedAt ||
				Date.now() - draft.draftSavedAt >= DRAFT_TTL_MS)
		) {
			localStorage.removeItem(key);
		}
	}, []);

	useEffect(() => {
		dispatch(analyticsAction.buyerOrdersList(data));
	}, [data]);

	useEffect(() => {
		fetchVendors({
			entity: 'ALL_VENDORS',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
		return () => {
			resetInventoryAnalyticsState({
				entity: 'INVENTORY_ANALYTICS',
				method: 'VENDOR_ORDERS_LIST',
				data: [],
			});
		};
	}, []);


	const BUYER_SPECIAL_ITEMS = {
		'Order Status': (itemId) => {
			const item = data?.find((poItem) => poItem?.id === itemId);
			const status = item?.orderStatus;

			const style = getStatusStyle(status);

			if (status === 'APPROVAL_REJECTED') {
				return (
					<div
						className="text-[12px] text-center px-2 py-2 rounded"
						style={style}
					>
						<p>
							{status?.split('_')?.join(' ')}
							{item?.jsonData?.rejectionReason
								? ` (Reason: ${item?.jsonData?.rejectionReason})`
								: ''}
						</p>
					</div>
				);
			}
			return (
				<div
					className="text-[12px] text-center px-2 py-2 rounded"
					style={style}
				>
					{handleOrderStatus(status)}
				</div>
			);
		},
		'Last Action BY': (lastActionBy, item) => {
			const isAutoApproved = item?.jsonData?.autoApproveResult?.autoApproveStatus;
			return (
				<div className="flex flex-col items-center gap-0.5 text-[12px] text-left">
					{isAutoApproved && (
						<div className='text-yellow-600 text-xs'>
							AUTO APPROVED
						</div>
					)}
					<div className="text-md">
						{lastActionBy}
					</div>
				</div>
			);
		},
		'Order Amount': (itemId) => {
			const item = data?.find((poItem) => poItem?.id === itemId);
			return (
				<div className="text-[12px] text-left">
					₹{item?.finalValue >= 0 ? addCommas(item?.finalValue) : '-'}
				</div>
			);
		},
		'Repush': (itemId) => {
			const item = data?.find((poItem) => poItem?.id === itemId);
			// jsonData.sync.SALES_ORDER is set by the backend integration flow:
			// true  -> pushed to SAP successfully
			// false -> push failed, offer a re-push action
			// undefined -> order was never pushed (nothing to show)
			const salesOrderSync = item?.jsonData?.sync?.SALES_ORDER;
			if (salesOrderSync === false) {
				return (
					<div className="flex justify-center">
						<Button
							onClick={(e) => {
								e.stopPropagation();
								handleRePushToSap(item);
							}}
							className="bg-red-500 hover:bg-red-600 rounded-md text-white text-[11px] normal-case px-3 py-1"
						>
							Push to SAP
						</Button>
					</div>
				);
			}
			if (salesOrderSync === true) {
				return (
					<div className="text-[12px] text-center text-green-600 font-medium">
						Synced
					</div>
				);
			}
			return <div className="text-[12px] text-center">-</div>;
		},
		Download: (itemId) => {
			const item = data?.find((poItem) => poItem?.id === itemId);
			return renderDownloadField(item);
		},
		Buyer: (vendorName) => {
			return (
				<div className="text-[12px] text-left" style={{ width: '100px' }}>
					{vendorName ?? '-'}
				</div>
			);
		},
		'Order Date': (itemId) => {
			const item = data?.find((poItem) => poItem?.id === itemId);
			return (
				<div className="text-[12px] text-left" style={{ width: '100px' }}>
					{moment(item?.createdAt)?.format('YYYY-MM-DD') ?? '-'}
				</div>
			);
		},
		'SO Id': (soId) => (
			<div className="text-[12px] text-left">{soId ?? '-'}</div>
		),
		'Client SO Id': (clientSoId) => (
			<div className="text-[12px] text-left">{clientSoId ?? '-'}</div>
		),
		'Order Ref No': (orderRefNo) => (
			<div className="text-[12px] text-left">{orderRefNo ?? '-'}</div>
		),
		'Dispatch By': (dispatchBy) => (
			<div className="text-[12px] text-left">{dispatchBy ?? '-'}</div>
		),
		'Deliver From': (deliverFrom) => (
			<div className="text-[12px] text-left">{deliverFrom ?? '-'}</div>
		),
		'CREATED BY': (createdBy) => (
			<div className="text-[12px] text-left">{createdBy ?? '-'}</div>
		),
	};


	const fetchBuyerOrders = (filters, isRefresh = false) => {
		setIsRefresh(isRefresh);
		setFilterValue(filters);
		const filterDateRangeFilter = {
			dateType: filters?.timeType?.value,
			from: moment(filters?.dateRange?.from).format('YYYY-MM-DD'),
			to: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
		};
		const buyerOrderFilters = {
			fromStoreId: filters?.store?.id,
			status: filters?.status,
			storeId: filters?.deliverFrom?.id === -999 ? null : filters?.deliverFrom?.id,
			vendors: Array.isArray(filters?.buyer) ? filters?.buyer.map(item => item?.id ?? item) : filters?.buyer?.id,
			variantIds: [...new Set(filters?.productWithVariant?.productData?.flatMap(item => item?.variantIds))],
			orderType: 'buyers',
			userOrderType: 'sales',
			dateRangeFilter: filterDateRangeFilter,
		};
		exportFilters.current = buyerOrderFilters;
		const req = {
			data: {
				filters: buyerOrderFilters,
			},
		};
		fetchOrdersList({
			entity: 'INVENTORY_ANALYTICS',
			method: 'VENDOR_ORDERS_LIST',
			req,
		});
	};

	const handleRefreshBuyerOrders = async () => {
		if (Number(appConfig?.customerId) === 5 || Number(appConfig?.customerId) === 72) {
			try {
				setLoading(true);
				const response = await orderAnalyticsServices.placeNagaBuyerOrders({
					data: {},
				});
				const isSuccess =
					response?.statusCode != null
						? response?.statusCode === 200
						: !!response;
				// Always surface the backend message (success, skipped orders,
				// or error) so the user can see what needs fixing on their side.
				if (response?.message) {
					notificationServices.generateNotification({
						type: isSuccess ? 'success' : 'error',
						message: response.message,
					});
				}
				if (!isSuccess) {
					return;
				}
			} catch (error) {
				notificationServices.generateNotification({
					type: 'error',
					message: error?.message || error || 'Failed to refresh buyer orders',
				});
				return;
			} finally {
				setLoading(false);
			}
		}
		fetchBuyerOrders(filterValue, true);
	};


	// Re-push a buyer order to SAP as a SALES_ORDER when its integration sync
	// status came back false. The button is only rendered for such orders.
	const handleRePushToSap = async (item) => {
		if (!item?.id) {
			return;
		}
		try {
			setLoading(true);
			const response = await orderAnalyticsServices.rePushToSap({
				data: {
					type: 'SALES_ORDER',
					objId: item.id,
				},
			});
			const isSuccess =
				response?.isSuccess ??
				(response?.statusCode != null
					? response?.statusCode === 200
					: !!response);
			notificationServices.generateNotification({
				type: isSuccess ? 'success' : 'error',
				message:
					response?.message ||
					(isSuccess
						? 'Order pushed to SAP successfully'
						: 'Failed to push order to SAP'),
			});
			if (isSuccess) {
				fetchBuyerOrders(filterValue, true);
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error?.message || error || 'Failed to push order to SAP',
			});
		} finally {
			setLoading(false);
		}
	};

	const handleExport = async (filters) => {
		try {
			setLoading(true);
			const response =
				await orderAnalyticsServices.exportGRNWiseOrderHistory({
					data: {
						filters: {
							...filters,
							vendors: filters?.buyers,
						},
					},
				});
			if (response.status === 200) {
				const exportType = buyerOrdersExportTypes?.find((ele) => {
					return ele?.value === filters?.exportType;
				});
				const exportTypeValue = exportType?.label
					?.split(' ')
					?.join('_')
					?.toUpperCase();
				const buyerExportTypeValue = exportTypeValue === 'INVOICE-WISE_SALES_REGISTER' ? 'INVOICE-WISE_SALES_REGISTER' : exportTypeValue === 'ITEM-WISE_SALES_REGISTER' ? 'ITEM-WISE_SALES_REGISTER' : exportTypeValue;
				let exportFileName = `BUYER_${buyerExportTypeValue}_ORDERS_${filters?.dateRangeFilter?.from}_${filters?.dateRangeFilter?.to}.csv`;
				handleResponseStreamDownload(response, exportFileName);
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Some error occurred',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error,
			});
		} finally {
			setLoading(false);
		}
	};

	const DATE_TYPES = useMemo(() => {
		return buyerDateTypeArr?.filter((ele) => {
			return !(ele?.value === 'received' || ele?.value === 'grn');
		});
	}, []);

	const handleOnUpdate = (filters) => {
		const filterDateRangeFilter = {
			dateType: filters?.timeType,
			from: moment(filters?.dateRange?.from).format('YYYY-MM-DD'),
			to: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
		};
		const buyerOrderFilters = {
			fromStoreId: filters?.store?.id,
			status: filters?.status,
			storeId:
				navSelectedStore?.value?.id === -999
					? null
					: navSelectedStore?.value?.id,
			buyers: Array.isArray(filters?.buyer) ? filters?.buyer.map(item => item?.id ?? item).join(',') : filters?.buyer?.id ?? filters?.buyer,
			orderType: 'buyers',
			userOrderType: 'sales',
			dateRangeFilter: filterDateRangeFilter,
		};
		exportFilters.current = buyerOrderFilters;
	};

	const buyerFilters = {
		header: {
			store: false,
			date: false,
			statusAndTypes: false,
			product: false,
		},
		store: {
			text: 'Deliver From',
			show: true,
			permittedStore: true,
		},
		buyer: {
			text: 'Buyer',
			show: true,
		},
		status: {
			text: 'Order Status',
			show: true,
		},
		dateRangeWithType: {
			text: 'Date Range',
			show: true,
		},
		timeType: {
			text: 'Date Time Type',
			show: true,
		},
		productWithVariants: {
			text: 'Product',
			show: true,
		},
	};

	const buyerDropDownItems = [
		{
			label: 'Client SO ID',
			value: 'clientSoId',
			placeholder: 'Search by Client SO ID',
			getData: true,
		},
		{
			label: 'SO ID',
			value: 'soId',
			placeholder: 'Search by SO ID',
			getData: true,
		},
		{
			label: 'Order Ref No',
			value: 'orderRefNo',
			placeholder: 'Search by Order Ref No',
			getData: true,
		},
		{
			label: 'Invoice No',
			value: 'invoiceNo',
			placeholder: 'Search by Invoice No',
			getData: true,
		}
	];

	useEffect(() => {
		if (search?.keyPress && search?.searchValue?.trim() === '') {
			fetchBuyerOrders(filterValue);
		}
	}, [search?.searchValue]);

	const idSearch = () => {
		const filters = {
			orderType: 'buyers',
			userOrderType: 'sales',
			...(search?.value === 'clientSoId' ? { clientPoId: search?.searchValue } : {}),
			...(search?.value === 'soId' ? { poId: Number(search?.searchValue) } : {}),
			...(search?.value === 'orderRefNo' && { orderRefNo: search?.searchValue }),
			...(search?.value === 'invoiceNo' && { invoiceNo: search?.searchValue }),
		};
		const req = {
			data: {
				filters: filters,
			},
		};
		fetchOrdersList({
			entity: 'INVENTORY_ANALYTICS',
			method: 'VENDOR_ORDERS_LIST',
			req,
		});
	};

	const handleCall = (e) => {
		if (e.key === 'Enter') {
			idSearch();
		}
	};

	const exportInfo = {
		showDropDown: true,
		showExportBtn: true,
		exportTypes: buyerOrdersExportTypes,
	};

	return (
		<div className={styles.root}>
			<BackdropLoader showProgress isLoading={loading} />
			<MultiPoModal />
			<div className={styles.header}>
				<ImagesFinder
					onSubmit={fetchBuyerOrders}
					update={update}
					timeTypeArray={DATE_TYPES}
					statusList={
						buyerOrderStatus?.map((ele) => {
							if (ele === 'FULFILLED') {
								return {
									id: ele,
									title: 'CLOSED',
								};
							}
							if (ele === 'TRANSIT') {
								return {
									id: ele,
									title: 'IN TRANSIT',
								};
							}
							if (ele === 'DISPATCH') {
								return {
									id: ele,
									title: 'PENDING DISPATCH',
								};
							}
							if (ele === 'UNLOADING') {
								return {
									id: ele,
									title: 'UNLOADING STARTED',
								};
							}
							if (ele === 'VERIFICATION') {
								return {
									id: ele,
									title: 'PENDING VERIFICATION',
								};
							}
							return {
								id: ele,
								title: ele,
							};
						})
					}
					onUpdate={handleOnUpdate}
					preventDateRangeCheckbox
					filtersInfo={buyerFilters}
					orderText
					exportInfo={exportInfo}
				/>
			</div>
			<div className='flex justify-between items-center w-full p-3'>
				<span className='font-bold text-[16px]'>
					Buyer Orders
				</span>
				<div className='flex items-center gap-2'>
					{level !== 1 && (
						<>
							<Button
								onClick={() => {
									dispatch(
										modalActions.toggleMultiplePoModal(
											true,
											{
												mode: 'buyerOrder',
											}
										)
									);
								}}
								className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
							>
								+ Create Multiple Buyer Order
							</Button>
							{/* Check for draft existence */}
							{(function () {
								const typeId = 8; // Buyer type
								const storageKey = getStorageKey(typeId);
								const draft = loadState(storageKey);
								// Show "Edit Draft" only while the draft is fresh
								// (saved within the last 30 minutes).
								const DRAFT_TTL_MS = 30 * 60 * 1000;
								const isDraftFresh =
									draft?.draftSavedAt &&
									Date.now() - draft.draftSavedAt < DRAFT_TTL_MS;

								if (draft && isDraftFresh) {
									return (
										<Button
											onClick={() => {
												const baseUrl = navSelectedStore?.value?.id !== -999
													? `${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER}?userOrderType=purchase&typeId=${typeId}`
													: `${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER}?typeId=${typeId}&userOrderType=purchase`;

												history.push(
													`${baseUrl}${baseUrl.includes('?')
														? '&'
														: '?'
													}editDraft=true`,
													{
														prevPath:
															location?.pathname +
															location?.search,
													}
												);
											}}
											className='animate-bounce bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 rounded-md flex items-center justify-center gap-2 text-white shadow-lg transform transition-all duration-1000 hover:scale-105'
										>
											<svg
												xmlns='http://www.w3.org/2000/svg'
												className='h-5 w-5'
												viewBox='0 0 20 20'
												fill='currentColor'
											>
												<path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
											</svg>
											Edit Draft
										</Button>
									);
								}
								return null;
							})()}

							<Button
								onClick={() => {
									const typeId = 8; // Buyer type
									const baseUrl = navSelectedStore?.value?.id !== -999
										? `${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER}?userOrderType=purchase&typeId=${typeId}`
										: `${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER}?typeId=${typeId}&userOrderType=purchase`;
									const storageKey = getStorageKey(typeId);
									const draft = loadState(storageKey);
									const DRAFT_TTL_MS = 30 * 60 * 1000;
									const isDraftFresh =
										draft?.draftSavedAt &&
										Date.now() - draft.draftSavedAt < DRAFT_TTL_MS;
									// A draft older than 30 mins is discarded, not offered for editing.
									if (draft && !isDraftFresh) {
										localStorage.removeItem(storageKey);
									}
									if (draft && isDraftFresh) {
										toggleAlert(true, {
											heading: 'Draft Exists',
											message: 'There is already a draft for this order type. Would you like to edit the draft or create a new order?',
											confirmText: 'Edit Draft',
											cancelText: 'Create New',
											colorReverse: false,
											handleConfirm: () => {
												let redirectUrl = baseUrl;
												if (redirectUrl.includes('?')) {
													redirectUrl += '&editDraft=true';
												} else {
													redirectUrl += '?editDraft=true';
												}
												history.push(redirectUrl, {
													prevPath: location?.pathname + location?.search,
												});
												toggleAlert(false);
											},
											handleCancel: () => {
												localStorage.removeItem(getStorageKey(typeId))
												history.push(baseUrl, {
													prevPath: location?.pathname + location?.search,
												});
												toggleAlert(false);
											},
										});
									} else {
										history.push(baseUrl, {
											prevPath: location?.pathname + location?.search,
										});
									}
								}}
								className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
							>
								+ Create Order
							</Button>
						</>
					)}
				</div>
			</div>
			<div className='flex gap-3 w-full justify-start items-center py-1'>
				<div className='w-[82%]'>
					<GlobalSearch
						dropDownOptions={
							buyerDropDownItems
						}
						setSelectedValue={setSearch}
						handleValue={handleCall}
						pageType='BUYER'
						isRefresh={isRefresh}
					/>
				</div>
				<Tooltip
					title={
						'Refresh Buyer Orders'
					}
				>
					<RefreshCcw
						className='size-5 cursor-pointer'
						onClick={handleRefreshBuyerOrders}
					/>
				</Tooltip>
				<Button
					onClick={() => {
						toggleFiltersDrawer(true, {
							handleDataExport: (filtersState) => {
								return handleExport({
									...exportFilters.current,
									dateRangeFilter: {
										dateType: filtersState?.timeType?.value,
										from: moment(
											filtersState?.dateRange?.from
										).format('YYYY-MM-DD'),
										to: moment(
											filtersState?.dateRange?.to
										).format('YYYY-MM-DD'),
									},
									fromStoreId: filtersState?.store?.id,
									variantIds: [...new Set(filtersState?.productWithVariant?.productData?.flatMap(item => item?.variantIds))],
									"orderType": "buyers",
									"userOrderType": "sales",
									exportType: filtersState?.exportType,
								});
							}
						});
					}}
					className='flex items-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
				>
					<span className='text-nowrap'>Filter & Export</span>
					<Filter className='size-4' />
				</Button>
			</div>
			{filtersInfoChip(
				buyerFilters,
				filterValue
			)}
			<div
				className='overflow-auto w-full max-h-[calc(100vh-250px)]'
			>
				<ListTable
					hasDateRange
					allowChangeColumn
					colMap={BUYER_COLMAP}
					fixedHeaderTop='0'
					columns={BUYER_TABLE_COLUMNS}
					data={data?.map((ele) => {
						return {
							...ele,
							onClick: () => history.push({
								pathname: `${urls.EXTENSION}${urls.BUYER_SALES_DETAILS}`,
								search: `?poId=${ele?.id}`,
								state: {
									prevPath: location.pathname + location.search,
								},
							}),
						};
					})}
					actions={[...BUYER_SPECIAL_COLUMNS]}
					special={BUYER_SPECIAL_ITEMS}
					allowExport={false}
				/>
			</div>
		</div>
	);
}

const mapStateToProps = (state) => {
	const { navState, userPermissions } = state?.navigation;
	const { VENDOR_ORDERS_LIST: data } = state?.analytics?.INVENTORY_ANALYTICS;
	const { DATE_RANGE_FILTER: dateRangeFilter } = state.analytics;
	const { LIST: vendors } = state.form.ALL_VENDORS.data;
	const categoriesList = state.form.PRODUCT_CATEGORY.data.LIST;
	const subCategoriesList = state.form.PRODUCT_SUB_CATEGORY.data.LIST;
	const { userList } = state?.auth;
	return {
		data,
		dateRangeFilter,
		navState,
		userPermissions,
		vendors,
		categoriesList,
		subCategoriesList,
		userList,
	};
};

const mapDispatchToProps = {
	setDateRangeFilter: analyticsAction.setDateRangeFilter,
	toggleModal: modalActions.togglePOItemsModal,
	toggleVendorOrderGrnsModal: modalActions.toggleVendorOrderGrnsModal,
	toggleAlert: modalActions.toggleAlert,
	toggleVanImageModal: modalActions.toggleVanImageModal,
	// toggleFileUploaderModal: modalActions.toggleFileUploaderModal,
	toggleTransactionsModal: modalActions.toggleTransactionsModal,
	fetchOrdersList: analyticsAction.gateway,
	fetchVendors: formActions.gateway,
	resetInventoryAnalyticsState: analyticsAction.resetInventoryAnalyticsState,
	toggleExportFiltersDrawer: drawerActions.toggleExportFiltersDrawer,
	fetchSubCategories: formActions.gateway,
	toggleDebitCreditListDrawer: drawerActions.toggleDebitCreditListDrawer,
	toggleAssetTransit: modalActions.toggleAssetTransit,
	fetchUserList: authActions?.fetchUserList,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
	toggleOrderImagesModal: modalActions.toggleOrderImagesModal
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(BuyerOrderList);
